module.exports = __webpack_public_path__ + "img/KPI_Process_Flow.3ec553e2.jpeg";